import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IItemConfigSet, IItemConfig } from "../interfaces/iitemconfig";
import { ItemConfigService } from "../services/itemconfig.service";
import { Observable } from "rxjs";

@Injectable()
export class ItemConfigSetResolver implements Resolve<IItemConfigSet> {
    constructor(private itemConfigService: ItemConfigService) {
    }
    resolve(route: ActivatedRouteSnapshot): Observable<IItemConfigSet> {
        return this.itemConfigService.getConfigSet();
    }
}

@Injectable()
export class ItemConfigSetByCountryAndIdResolver implements Resolve<IItemConfigSet> {
    constructor(private itemConfigService: ItemConfigService) {
    }
    resolve(route: ActivatedRouteSnapshot): Observable<IItemConfigSet> {
        return this.itemConfigService.getConfigSetByCountryAndItemConfigId(route.params["countryCode"], route.params["id"]);
    }
}

@Injectable()
export class ItemConfigResolver implements Resolve<IItemConfig> {
    constructor(private itemConfigService: ItemConfigService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IItemConfig> {
        return this.itemConfigService.getItem(route.params["id"]);
    }
}

